import { render, staticRenderFns } from "./MyFolderMsgModal.vue?vue&type=template&id=8e0272ba&"
import script from "./MyFolderMsgModal.vue?vue&type=script&lang=ts&"
export * from "./MyFolderMsgModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports